var theme = {
  init: function () {
    this.subMenu();
    this.offCanvas();
    this.onepageHeaderOffset();
    this.anchorSmoothScroll();
    this.svgInject();
    this.rellax();
    this.scrollCue();
    // this.stickyHeader(); // enable only if needed
    // this.isotope();      // enable only if grid exists
  },

  /* Sticky Header */
  stickyHeader: function () {
    var navbar = document.querySelector(".navbar");
    if (!navbar) return;

    var options = {
      offset: 350,
      offsetSide: 'top',
      classes: {
        clone: 'navbar-clone fixed',
        stick: 'navbar-stick',
        unstick: 'navbar-unstick',
      },
      onStick: function () {
        var cls = this.clonedElem.classList;
        if (cls.contains('transparent') && cls.contains('navbar-dark')) {
          this.clonedElem.classList.replace('navbar-dark', 'navbar-light');
        }
      }
    };

    new Headhesive('.navbar', options);
  },

  /* Sub Menus */
  subMenu: function () {
    (function ($bs) {
      const CLASS_NAME = 'has-child-dropdown-show';

      $bs.Dropdown.prototype.toggle = (function (original) {
        return function () {
          document.querySelectorAll('.' + CLASS_NAME)
            .forEach(e => e.classList.remove(CLASS_NAME));

          let dd = this._element.closest('.dropdown')
            ?.parentNode.closest('.dropdown');

          for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
            dd.classList.add(CLASS_NAME);
          }
          return original.call(this);
        };
      })($bs.Dropdown.prototype.toggle);

      document.querySelectorAll('.dropdown').forEach(dd => {
        dd.addEventListener('hide.bs.dropdown', function (e) {
          if (this.classList.contains(CLASS_NAME)) {
            this.classList.remove(CLASS_NAME);
            e.preventDefault();
          }
          e.stopPropagation();
        });
      });
    })(bootstrap);
  },

  /* Offcanvas */
  offCanvas: function () {
    var navbar = document.querySelector(".navbar");
    if (!navbar) return;

    const nav = document.querySelector('.navbar:not(.navbar-clone) .offcanvas-nav');
    if (!nav) return;

    const bsOffCanvas = new bootstrap.Offcanvas(nav, { scroll: true });

    document.querySelectorAll(".offcanvas-nav-btn")
      .forEach(btn => btn.addEventListener('click', () => bsOffCanvas.show()));

    document.querySelectorAll('.onepage .navbar li a.scroll')
      .forEach(link => link.addEventListener('click', () => bsOffCanvas.hide()));

    const search = document.getElementById('offcanvas-search');
    if (search) {
      search.addEventListener('shown.bs.offcanvas', () => {
        document.getElementById("search-form")?.focus();
      });
    }
  },

  /* Onepage Offset */
  onepageHeaderOffset: function () {
    var navbar = document.querySelector(".navbar");
    if (!navbar) return;

    const headerHeight = navbar.offsetHeight;
    const shrinkHeight = 75;

    document.querySelectorAll(".onepage section").forEach(sec => {
      sec.style.paddingTop = shrinkHeight + 'px';
      sec.style.marginTop = '-' + shrinkHeight + 'px';
    });

    const first = document.querySelector(".onepage section:first-of-type");
    if (first) {
      first.style.paddingTop = headerHeight + 'px';
      first.style.marginTop = '-' + headerHeight + 'px';
    }
  },

  /* Smooth Scroll */
  anchorSmoothScroll: function () {
    document.querySelectorAll(".scroll").forEach(link => {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute("href"));
        if (!target) return;

        window.scroll({
          top: target.offsetTop,
          behavior: "smooth"
        });
      });
    });
  },

  /* SVG Inject */
  svgInject: function () {
    SVGInject.setOptions({
      onFail: img => img.classList.remove('svg-inject')
    });

    SVGInject(document.querySelectorAll('img.svg-inject'), { useCache: true });
  },

  /* Rellax */
  rellax: function () {
    if (!document.querySelector(".rellax")) return;

    window.addEventListener('load', () => {
      const rellax = new Rellax('.rellax', {
        speed: 2,
        center: true,
        breakpoints: [576, 992, 1201]
      });

      imagesLoaded('.projects-overflow', () => rellax.refresh());
    });
  },

  /* ScrollCue */
  scrollCue: function () {
    scrollCue.init({
      interval: -400,
      duration: 700,
      percentage: 0.8
    });
    scrollCue.update();
  }
};

document.addEventListener('DOMContentLoaded', () => theme.init());
